import styled from 'styled-components';
export const Label = styled.div `
  // position
  ${({ type, theme }) => {
    if (type.includes('tlpa2')) {
        return `position: absolute;
      bottom: 0rem;
      background-color: ${theme.colors.white};`;
    }
    return '';
}};

  display: flex;
  box-sizing: border-box;

  /* border-color */
  ${({ type, theme }) => {
    if (type.includes('tlpa3')) {
        return `border-top: 1px solid ${theme.colors.grey06};`;
    }
    return '';
}};

  /* background-color */
  ${({ type, theme }) => {
    if (type.includes('tlpa3-a')) {
        return `background-color: ${theme.colors.grey03};`;
    }
    if (type.includes('tlpa3-b')) {
        return `background-color: ${theme.colors.white};`;
    }
    return '';
}};

  /* height */
  ${({ type }) => {
    if (type === 'tlpa2') {
        return `height: 2rem;`;
    }
    return 'height: auto;';
}}

  /* padding */
  ${({ type }) => {
    if (type === 'tlpa1-a') {
        return `padding-top: 0.75rem;`;
    }
    if (type === 'tlpa2') {
        return `padding: 0.5rem;`;
    }
    if (type.includes('tlpa3')) {
        return `padding: 0.75rem 0.75rem 1rem 0.75rem;`;
    }
    return '';
}}

  ${({ type }) => {
    if (type === 'tlpa1-a') {
        return `align-items: center;justify-content: flex-start;`;
    }
    if (type === 'tlpa2') {
        return `
      display: initial;
      text-aligh: center;
      width: 100%;
      white-space: nowrap;
      overflow: hidden; 
      text-overflow: ellipsis;
      `;
    }
    if (type.includes('tlpa3')) {
        return `flex: 1;justify-content: flex-start;align-items: flex-start;`;
    }
    return `align-items: flex-end;`;
}}

  ${({ type }) => `text-align: ${type.includes('tlpa1-a') ? 'center' : 'left'};`}
  ${({ type }) => {
    if (type.includes('tlpa1')) {
        return `
      font-size: 0.8125rem;
      font-weight: 500;
      line-height: 1rem;
      `;
    }
    if (type.includes('tlpa2') || type.includes('tlpa3')) {
        return `
      font-size: 0.875rem;
      font-weight: 400;
      line-height: 1.25rem;
      `;
    }
    return '';
}}
  ${({ type }) => `text-align: ${type === 'tlpa2' ? 'center' : 'left'};`}
`;
